import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSubAgent } from '../actions/subagentActions'
import Country from '../components/Country'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { SUB_AGENT_CREATE_RESET } from '../constants/subagentConstants'
import { subagentJson } from '../models/subagentModel'

export default function SubAgentCreateScreen() {
    const dispatch = useDispatch();

    const [parameters, setParameters] = useState(subagentJson);

    const subAgentCreate = useSelector(state => state.subAgentCreate)
    const { loading, error, success } = subAgentCreate

    const handleSubAgentValue = (e) => {
        setParameters({ ...parameters, [e.target.name]: e.target.value });
    }

    const SaveSubAgent = (e) => {
        dispatch(createSubAgent(parameters))
        // console.log(parameters)
    }

    useEffect(() => {
        if (success) {
            setParameters(subagentJson);
            setTimeout(() => {
                dispatch({
                    type: SUB_AGENT_CREATE_RESET
                })
            }, 10000);
        }

    }, [dispatch, success])

    return (
        <>
            <Header pageName="Sub Agents" />
            <LeftComponent />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-title float-left">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Sub Agent Details
                                            </a>
                                        </div>

                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Sub Agent Name* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="sub agent name"
                                                                name="SubAgent_Name"
                                                                value={parameters.SubAgent_Name}
                                                                onChange={e => handleSubAgentValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Sub Agent Address* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            {/* <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div> */}
                                                            <textarea className="form-control form-control-sm" placeholder="address..."
                                                                name="SubAgent_Address"
                                                                value={parameters.SubAgent_Address}
                                                                onChange={e => handleSubAgentValue(e)}></textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={parameters.Country_Id}
                                                                onChange={e => handleSubAgentValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Country />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" >
                                            <a className="card-title">
                                                Other Details
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" >
                                            <div className="row">
                                                <div className="col-md-6">

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Person" value={parameters.Contact_Person} onChange={e => handleSubAgentValue(e)} placeholder="contact person" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Email*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Email" value={parameters.Contact_Email} onChange={e => handleSubAgentValue(e)} placeholder="contact person email" />

                                                        </div>
                                                    </div>

                                                   
                                                </div>

                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Number*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Number" value={parameters.Contact_Number} onChange={e => handleSubAgentValue(e)} placeholder="contact person number" />

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="card-header collapsed"   >
                                            <a className="card-title">
                                                Commission Details
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="card-body collapse  show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Split Percentage*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="split percentage" name="Split_Percentage" value={parameters.Split_Percentage} onChange={e => handleSubAgentValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage UG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage" name="Commision_Percentage_UG" value={parameters.Commision_Percentage_UG} onChange={e => handleSubAgentValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision_Percentage_PG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage pg" name="Commision_Percentage_PG" value={parameters.Commision_Percentage_PG} onChange={e => handleSubAgentValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision_Percentage_Other*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage other" name="Commision_Percentage_Other" value={parameters.Commision_Percentage_Other} onChange={e => handleSubAgentValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Lumpsum_Commision</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div>
                                                            <input type="text" className="form-control form-control-sm" placeholder="Lumpson Commission" name="Lumpsum_Commision" value={parameters.Lumpsum_Commision} onChange={e => handleSubAgentValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision Including GST</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Commision_Including_GST" value={parameters.Commision_Including_GST} onChange={(e) => handleSubAgentValue(e)}>
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Duration</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Commission_Duration" value={parameters.Commission_Duration} onChange={e => handleSubAgentValue(e)} placeholder="commission duration"
                                                            />

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    <>
                                                        {
                                                            loading ? (
                                                                <div className="Create-btn">
                                                                    Loading...
                                                                </div>
                                                            ) : (
                                                                <div className="Create-btn">
                                                                    <a className="btn create-contact"
                                                                        onClick={e => SaveSubAgent(e)}>Save</a>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                    <span className='text-success'>{success}</span>
                                                    <span className='text-danger'>{error}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

